
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class mErrorDisplay extends Vue {
  @Prop({ type: Array, default: () => [] }) errors: string[];
}
